module.exports = __webpack_public_path__ + "12c6e7f266061ea69130fb4577e2f077.svg";